module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "margin": "80px 0 0 30px"
    }
  }, [_c('div', {
    staticClass: "onestepcheckout-place-order-loading",
    staticStyle: {
      "display": "block"
    }
  }, [_c('img', {
    attrs: {
      "src": "//img.fancyecommerce.com/images/opc-ajax-loader.gif"
    }
  }), _vm._v("  \n            Please wait, processing your order...\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ee5de040!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/payment/alipay/standard/Review.vue
// module id = 270
// module chunks = 1